import { dateRelativeFromUTC } from 'utils/dayjs';

class Purchase {
    constructor(store, data) {
        this.id = data.id;
        this.pk = data.pk;
        this.store = store;
        this.data = data;
    }

    updateFromJson(json) {
    }

    get canBePaid() {
        return this.data.payment?.status !== 'A_1' && this.data.source === 'A_1';
    }

    get isPaid() {
        return this.data.payment?.status === 'A_1';
    }

    get createdAt() {
        return dateRelativeFromUTC(this.data.createdAt);
    }

    setPaid() {
        if (this.data.payment) {
            this.data.payment.status = 'A_1';
        } else {
            this.data.payment = {
                status: 'A_1'
            }
        }
    }
}

export default Purchase
